/**
 * @voltxampere/components — Independent current source
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
export const CurrentSourceParamsSchema = z
    .object({
    /** DC value in amps. */
    current: z.number().finite(),
    /** Optional AC magnitude in amps. */
    acMagnitude: z.number().nonnegative().finite().optional(),
    /** Optional AC phase in degrees. */
    acPhase: z.number().finite().optional(),
})
    .strict();
export const currentSourceDefinition = {
    type: "current-source",
    category: "source",
    displayName: { tr: "Akım Kaynağı", en: "Current Source" },
    symbol: "I",
    pins: [
        { id: "pos", side: "top", offset: 0, label: "+" },
        { id: "neg", side: "bottom", offset: 0, label: "-" },
    ],
    parameterSchema: CurrentSourceParamsSchema,
    nonlinear: false,
};
//# sourceMappingURL=current-source.js.map